import React from 'react';
import { ButtonBorderedKVBase, DefaultModal } from '@/presentation/components';
import { IconErrorAddPerson } from '@/presentation/components/icons';
import { TOTAL_STUDENTS_LIMIT_IN_SEMI_ANNUAL } from '@/presentation/constants/stripe-constants';
import { Container, Row } from 'react-bootstrap';
import { useRecoilState } from 'recoil';
import { manageStudentsAtom } from './atoms';
import Styles from './modal-limit-styles.scss';
const ModalLimit = ({ test }) => {
    const [manageStudentsState, setManageStudentsState] = useRecoilState(manageStudentsAtom);
    const closeModal = () => {
        setManageStudentsState(prev => (Object.assign(Object.assign({}, prev), { modalLimitExceeded: false })));
    };
    return (React.createElement(DefaultModal, { height: "54.59", hUnit: "vh", width: "35.5", wUnit: "vw", open: manageStudentsState.modalLimitExceeded, 
        // onClose={closeModal}
        // showClose
        overlayCustomStyles: { zIndex: 10000 }, contentCustomStyles: { padding: 25 } },
        React.createElement(Container, { className: Styles.wrap },
            React.createElement(Row, null,
                React.createElement(IconErrorAddPerson, null)),
            React.createElement(Row, null,
                React.createElement("span", { className: Styles.title }, "Student limit exceeded")),
            React.createElement(Row, null,
                React.createElement("span", { className: Styles.text },
                    "Your account type has a limit of ",
                    TOTAL_STUDENTS_LIMIT_IN_SEMI_ANNUAL,
                    " students. To continue, reduce the number of students you are trying to add to meet the limit.")),
            React.createElement(Row, null,
                React.createElement(ButtonBorderedKVBase, { type: "button", onClick: closeModal }, "Ok")))));
};
export default ModalLimit;
